<template lang="pug">
  div.position-relative
    div.ml-2.mr-2
      a.btn.btn-success(
        :class="[`btn-${btn_size}`]",
        :style="{ color: 'white', pointerEvents: is_loading ? 'none' : 'auto' }",
        @click="onClick"
      ) {{ btn_label }}

      div.d-flex.align-items-center
        UploadHeatmapImage(
          v-if="show_modal",
          @close-modal="show_modal = false"
          @set-loading="handleSetLoading"
          :token="token"
        )

    transition(name="fade")
      div.loading-overlay(v-show="is_loading")
        div.spinner
</template>

<script>
import UploadHeatmapImage from "./modals/upload_heatmap_image.vue";

export default {
  props: {
    btn_label: { type: String, default: "画像アップロード" },
    token: { type: String, default: "" },
    btn_size: { type: String, default: "sm" },
  },
  data() {
    return {
      show_modal: false,
      is_loading: false,
    };
  },
  methods: {
    onClick(e) {
      e.preventDefault();
      if (this.is_loading) return;
      this.show_modal = true;
      return false;
    },
    handleSetLoading(status) {
      this.is_loading = status;
    },
  },
  components: {
    UploadHeatmapImage,
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 6px solid #ccc;
  border-top: 6px solid #28a745;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
